import { Json } from '@gift/types/Json';

export const fontsInitialState: Json.Font[] = [
    {
        id: '747680a6-01b2-43b8-989d-a480b450f68c',
        name: 'Nunito',
        status: 'pending'
    },
    {
        id: '629d77aa-b8da-481c-a621-5f8814cd5253',
        name: 'Arial',
        status: 'pending'
    },
    {
        id: '0be8e745-60a7-430c-82f7-b2c91544c085',
        name: 'Comic Sans',
        status: 'pending'
    },
    {
        id: '50e988f0-cc88-44eb-8a40-b97b9f69833e',
        name: 'Georgia',
        status: 'pending'
    },
    {
        id: '2d689434-fbe8-4cf3-804c-3d14befaf22f',
        name: 'Akaya Kanadaka',
        status: 'pending'
    },
    {
        id: '97c78919-4a18-42b7-b9bb-6e24f32eb94c',
        name: 'Big Shoulders',
        status: 'pending'
    },
    {
        id: '25fd53df-a2b5-41fc-912b-730d07f7f81e',
        name: 'Caveat',
        status: 'pending'
    },
    {
        id: '600b779d-ed4b-4bd2-adc9-d53d9e1d9589',
        name: 'Roboto',
        status: 'pending'
    },
    {
        id: '67426641-45de-493b-b529-61a262914409',
        name: 'Crafty Girls',
        status: 'pending'
    },
    {
        id: '7bb73d57-d5d4-4bd5-bf94-8aa410b2779b',
        name: 'Dancing Script',
        status: 'pending'
    },
    {
        id: '5636e393-d6b0-462a-a428-fa9a7a2f5446',
        name: 'Sigmar One',
        status: 'pending'
    },
    {
        id: '4b4e2aff-f85e-4218-9d59-5866f077f3f9',
        name: 'Passion One',
        status: 'pending'
    },
    {
        id: '2f9bd83a-873e-4491-905a-150f8769259b',
        name: 'Glory',
        status: 'pending'
    },
    {
        id: '6a716d16-fb4a-43d5-95ee-4f344fdd6f2f',
        name: 'Amaranth',
        status: 'pending'
    },
    {
        id: '84ad4e9d-5af5-4124-9ca7-9a761488ff48',
        name: 'Tourney',
        status: 'pending'
    }
];
